const RecurrenceType = {
  Once: 'Once',
  Hourly: 'Hourly',
  Daily: 'Daily',
  Weekly: 'Weekly',
  Monthly: 'Monthly'
}

export default RecurrenceType
